import { apiGetList } from './ApiBaseActions';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY_SUCCESS';
/**
 * Proffit Searchの統計情報を取得（スライド合計枚数や人気タグなど）
 * @param data
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchSummary = (data, meta) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUMMARY, '/proffit_search/summary', data || {}, meta || {});
